import React from "react";
import { CheckCircle, MedalMilitary, Hourglass, ShieldWarning } from "@phosphor-icons/react";

export function VerifyBadge({ status }) {
  if (status === "verified")
    return (
      <span className="as-badge-verified" data-testid="kyc-verified">
        <CheckCircle size={14} weight="fill" />Verified
      </span>
    );
  if (status === "pending")
    return (
      <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-bold bg-amber-50 text-amber-700 border border-amber-200" data-testid="kyc-pending">
        <Hourglass size={14} weight="fill" />Pending
      </span>
    );
  return (
    <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-bold bg-stone-100 text-stone-600 border border-stone-200" data-testid="kyc-unverified">
      <ShieldWarning size={14} weight="fill" />Unverified
    </span>
  );
}

export function CustomBadge({ label }) {
  return (
    <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-bold bg-[var(--as-bg-alt)] text-[var(--as-primary)] border border-[var(--as-border)]" data-testid={`badge-${label.replace(/\s+/g,'-').toLowerCase()}`}>
      <MedalMilitary size={14} weight="duotone" />{label}
    </span>
  );
}

export function SkillChip({ children, onRemove, onClick, active }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`as-badge-skill cursor-pointer hover:bg-[var(--as-border)] ${active ? "!bg-[var(--as-primary)] !text-[var(--as-bg)] !border-[var(--as-primary)]" : ""}`}
      data-testid={`skill-chip-${String(children).toLowerCase().replace(/\s+/g,'-')}`}
    >
      {children}
      {onRemove && <span onClick={(e) => { e.stopPropagation(); onRemove(); }} className="ml-2 opacity-60 hover:opacity-100">×</span>}
    </button>
  );
}
